import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouth: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMouth"><Path d="M1 11.3278C1 11.3278 4.07804 4.51759 7.875 4.51759C9.57305 4.51759 12 5.87962 12 5.87962C12 5.87962 13.9998 4.6696 15.4375 4.51759C19.4063 4.09795 23 11.3278 23 11.3278M1 11.3278C1 11.3278 7.67975 9.5 12 9.5C16.3202 9.5 23 11.3278 23 11.3278M1 11.3278C1 11.3278 4.3 19.5 12 19.5C19.7 19.5 23 11.3278 23 11.3278M1 11.3278C1 11.3278 7.56806 14.5 12 14.5C16.4319 14.5 23 11.3278 23 11.3278" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconMouth;
